// extracted by mini-css-extract-plugin
module.exports = {"numeral":"styles_numeral_3ndLhn1sVSBoWr7B2PKhKN"};